import setCurrentPage from "src/Utils/setCurrentPage";
import setPreviousPage from "src/Utils/setPreviousPage";

const LIST_DATA_BENEFITS_TEMPLATE = [
  {
    icon: "worldAndSchemeLine",
    iconColor: "white",
    text: "Compliant to open standards from \nleading industry forums such as\n ETSI, TM Forum, 3GPP, etc",
    listItemCustomStyle: { width: "400px" },
  },
  {
    icon: "cloudWithScheme",
    iconColor: "white",
    text: "Versatile support: fully compatible \n with both private cloud and public\n CaaS providers",
    listItemCustomStyle: { width: "400px" },
  },
  {
    icon: "computerWithCloud",
    iconColor: "white",
    text: "Seamless integration with AWS \nTelco Network Builder service - Set\n up a private 5G core on AWS in\n just 30 minutes",
    listItemCustomStyle: { width: "400px" },
  },
];

export const DATA_BENEFITS_TCA_2 = {
  title: "Reduce time to market",
  titleNumber: "2.",
  text: "Elevate customer satisfaction and unlock new revenue streams with rapid roll-out of innovative \nofferings. Leverage industry blueprints & capabilities for unparalleled speed and success.",
  listData: LIST_DATA_BENEFITS_TEMPLATE,
  next: {
    label: "NEXT",
    onClick: () => setCurrentPage("ILO_304"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ILO_302"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/TCA/TCA_Intro_03.jpg",
  demoButtons: [
    {
      label: "Network DESIGNER DEMO",
      onClick: () => {
        setPreviousPage("ILO_303");
        setCurrentPage("ILO_306");
      },
      endIcon: "arrow-right",
    },
    {
      label: "Network operation team DEMO",
      onClick: () => {
        setPreviousPage("ILO_303");
        setCurrentPage("ILO_312");
      },
      endIcon: "arrow-right",
    },
  ],
};
